// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e1p9l","delete":"styles_delete__SKyk-","update":"styles_update__3qAuv","add":"styles_add__35JH4"};